import { Injectable } from '@angular/core';
import { SoftwareLineModel } from '../models/software-line.model';
import { SoftwareVersionModel } from '../models/software-version.model';

@Injectable({ providedIn: 'root' })
export class SoftwareService {
  lines: SoftwareLineModel[] = [
    { id: 's1', slug: 'lis',        name: 'LIS Software',        summary: 'Gestión integral de laboratorio clínico.' , logo: 'assets/logo/alp_plus.png'},
    { id: 's2', slug: 'blood-bank', name: 'Blood Bank',          summary: 'Banco de sangre y hemoterapia.', logo: 'assets/logo/alp_red.png' },
    { id: 's3', slug: 'vet-lis',    name: 'Vet LIS Software',    summary: 'Laboratorio veterinario.', logo: 'assets/logo/alp_vet.png' },
  ];
  versions: SoftwareVersionModel[] = [
    { id: 'v1', lineSlug: 'lis',        version: 'Basic',      features: ['Pacientes', 'Resultados', 'Reportes'] },
    { id: 'v2', lineSlug: 'lis',        version: 'Enterprise', features: ['Integraciones', 'Multi-sede', 'BI'] },
    { id: 'v3', lineSlug: 'blood-bank', version: 'Pro',        features: ['Donantes', 'Bolsas', 'Trazabilidad'] },
    { id: 'v4', lineSlug: 'vet-lis',    version: 'Pro',        features: ['Especies', 'Paneles', 'Historial'] },
  ];

  getLines() { return this.lines; }
  getLine(slug: 'lis'|'blood-bank'|'vet-lis') { return this.lines.find(l => l.slug === slug) || null; }
  getVersions(lineSlug: 'lis'|'blood-bank'|'vet-lis') { return this.versions.filter(v => v.lineSlug === lineSlug); }
}
